import React from 'react';
import HeroSection2 from './HeroSection2';
import PropertyTypes from './PropertyTypes';
import PopularDeals from './PopularDeals';
import AboutUs from './AboutUs';
import Counter from './Counter';
import Testimonial from './Testimonial';
import FeaturedProperties from './FeaturedProperties';
import Cta from './Cta';
import Footer from '../Layout/Footer';
import PropertyBookModal from './PropertyBookModal';

export default function Home2() {
  return (
    <>
      <HeroSection2/>
      <PropertyTypes/>
      <PopularDeals/>
      <AboutUs/>
      <Counter/>
      <Testimonial/>
      <FeaturedProperties/>
      <Cta/>
      <Footer/>
      <PropertyBookModal/>
    </>
  )
}
